import { keepPreviousData, useQuery } from "@tanstack/react-query";
import axiosClient from "../../../services/api/axiosInstance";
import { CurrentTokenUsage } from "../models";

export const TOKEN_CURRENT_USAGE_QUERY_KEY = "TokenCurrentUsage";

export const useTokenCurrentUsage = (customerId: string) =>
  useQuery<CurrentTokenUsage>({
    queryKey: [TOKEN_CURRENT_USAGE_QUERY_KEY, customerId],
    queryFn: async ({ signal }) => {
      const response = await axiosClient.get<CurrentTokenUsage>(
        `/api/v1/ai-settings/${customerId}/token-usage/current-month`,
        {
          signal,
        }
      );

      return response?.data;
    },
    placeholderData: keepPreviousData,
    staleTime: 60000,
  });
